import { render, staticRenderFns } from "./indicador-carga.vue?vue&type=template&id=33172d14&scoped=true&"
import script from "./indicador-carga.component.ts?vue&type=script&lang=ts&"
export * from "./indicador-carga.component.ts?vue&type=script&lang=ts&"
import style0 from "./indicador-carga.vue?vue&type=style&index=0&id=33172d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33172d14",
  null
  
)

export default component.exports